module.exports = __webpack_public_path__ + "static/prepare.ee583f03.png";